import { FormBase } from 'core/components';

export default class ClinicalStatusEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'CLINICAL_STATUS.EDIT.NAME_LABEL',
                    placeholder: 'CLINICAL_STATUS.EDIT.NAME_PLACEHOLDER',
                    rules: ['string', 'required'],
                },
                {
                    name: 'description',
                    label: 'CLINICAL_STATUS.EDIT.DESCRIPTION_LABEL',
                    placeholder: 'CLINICAL_STATUS.EDIT.DESCRIPTION_PLACEHOLDER',
                    rules: ['string'],
                }
            ],
        };
    }
}
